export { default as SelectMultipleQuestion } from './select-multiple';
